import * as actions from '../actions'

var defaultState = null

export default function entities(state = defaultState, action) {
    switch (action.type) {

        case actions.ENTITY_GET:
            if (!action.error) {
                state = action.payload.data.objects
            }
            return state

        case actions.ENTITY_CLEAN:
            return defaultState

        default:
            return state

    }
}



// WEBPACK FOOTER //
// ./state/reducers/entities.js